<template>
	<div v-if="startOfLoop" class="loop-upper-node">
		<LoopSvg />
		<div>Loop</div>
	</div>
	<div v-else class="loop-lower-node">Loop End</div>
</template>

<script>
import LoopSvg from '../assets/LoopSvg.vue';
export default {
	name: 'FlowTreeLoop',
	props: { startOfLoop: { type: Boolean } },
	components: { LoopSvg },
};
</script>

<style lang="scss" scoped>
.loop-upper-node {
	display: flex;
	flex-direction: column;
	transform: rotate(-45deg);
	font-size: 14px;
}
.loop-lower-node {
	position: absolute;
	top: 30px;
	left: -2px;
	transform: rotate(-45deg) translate(18%, 16%);
	font-size: 12px;
}
</style>
